import type { ShallowRef } from "vue";

export function moveActiveIndicator(
    parent: ShallowRef<HTMLElement | null>,
    indicator: ShallowRef<SVGSVGElement | null>,
    items: ShallowRef<HTMLElement[] | null>,
    index: number
) {
    if (!parent.value || !indicator.value || !items.value?.[index]) return;

    const width = items.value[index].clientWidth;
    const offset = parent.value.clientWidth - items.value[index].offsetLeft - width;
    indicator.value.style.transform = `translateX(-${ offset }px)`;
    indicator.value.style.width = `${ width }px`;
};

export function setIdByPath(value: string) {
    const route = useRoute();
    const splitedPath = route.path.split('/');
    const lastIndex = splitedPath.length - 1;
    const pageNameIndex = splitedPath[lastIndex] ?
      lastIndex :
      lastIndex - 1;
    return `${value}_${splitedPath[pageNameIndex]}`;
};

export function scrollToElementById(id: string, margin: number = 0) {
    const elem = document.getElementById(id);
    if (elem)
      window.scrollTo({ top: elem.offsetTop + margin, behavior: 'smooth' });
};

export function formatPrice(value: string) {
  return Number(value).toLocaleString();
};